"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasfatyUnit_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var WasfatyUnit_Factory = /** @class */ (function () {
    function WasfatyUnit_Factory() {
    }
    WasfatyUnit_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Active: model.Active,
            Code: model.Code,
            Id: model.Id,
            Name: model.Name,
            SecondLanguageName: model.SecondLanguageName,
        };
        return result;
    };
    WasfatyUnit_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Active: model.Active,
            Code: model.Code,
            Id: model.Id,
            Name: model.Name,
            SecondLanguageName: model.SecondLanguageName,
        };
        return result;
    };
    return WasfatyUnit_Factory;
}());
exports.WasfatyUnit_Factory = WasfatyUnit_Factory;
